import React from "react";

const Terms = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
      <h1 style={{ color: "#333" }}>Terms and Conditions</h1>
      <p>
        By registering on this platform, you acknowledge and agree to the following terms and conditions:
      </p>
      <ul>
        <li>
          Registration or the approval of your application does not in any way imply that the fees or financial obligations will be paid for.
        </li>
        <li>
          The platform solely provides an option for donors to view your application and consider supporting your cause at their discretion.
        </li>
        <li>
          Donor contributions are entirely voluntary, and no guarantees are made regarding receiving financial assistance.
        </li>
        <li>
          By using this platform, you agree to provide accurate and honest information in your application.
        </li>
      </ul>
      <p>
        For any questions or concerns regarding these terms, please contact us at <a href="mailto:support@example.com">support@example.com</a>.
      </p>
    </div>
  );
};

export default Terms;
